<div class="settings-wrapper">
    <div class="flex justify-between items-center w-full">
        <div class="flex items-center justify-start settings-header" style="gap: 13px;">
            <app-searchbar style="max-width: 620px; width: 620px;" placeholder="Buscar"></app-searchbar>
        </div>
        <app-welcome-user></app-welcome-user>
    </div>
    <div class="content-wrapper min-h-[714px]" *ngIf="!showDetails">
        <div class="flex justify-between w-full px-9">

            <p class="title mb-4">Perfiles de configuración</p>
            <app-accent-button class="h-10" text="Crear perfil de configuración" icon="fa-light fa-circle-plus mr-2"
                [selected]="true" (click)="createProfile()"></app-accent-button>
        </div>

        <div class="buttons-bar w-full"></div>

        <div class="flex justify-between items-center mx-9 mt-6 bg-quaternary h-14 rounded-container px-6 border border-tertiary"
            *ngFor="let profile of profiles">
            <p class="text-white">{{profile.name}}</p>
            <div class="flex">
                <span class="pl-10 text-white hover:text-grey cursor-pointer" (click)="openDetails(profile)">
                    Detalles
                    <i class="fal fa-eye" style="margin-left: 10px;"></i>
                </span>
            </div>
        </div>


        <!-- <div *ngIf="loading" class="loading-wrapper">
            <mat-spinner></mat-spinner>
            <p>Cargando...</p>
        </div> -->

    </div>
    <app-profile-details *ngIf="showDetails" [deatails]="showDetails" (changeDetails)="changeDetails($event)"
        [profile]='selectedProfile'></app-profile-details>
</div>